/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import State from './State';
import FormGroup from '../FormGroup';
import FormControl from '../FormControl';
import {Button, InputGroup} from 'react-bootstrap';
import InputGroupAppendIcon from '../InputGroupAppendIcon';

class PasswordField extends React.Component<Props, State> {

	static defaultProps: Props = {
		autoComplete: 'current-password',
		autoFocus: false,
		onChange: () => {
			// do nothing
		},
		onEnter: () => {
			// do nothing
		},
		password: '',
		violations: []
	};

	constructor(props: Props) {
		super(props);

		this.state = {passwordFieldType: 'password'};
	}

	handleVisibleToggle = (): void => {
		const state: Readonly<State> = this.state;

		this.setState({passwordFieldType: state.passwordFieldType === 'password' ? 'text' : 'password'});
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		const errorState: boolean = props.violations.length > 0;

		return (
			<FormGroup controlId="password" label="Wachtwoord:" violations={props.violations}>
				<InputGroup className={errorState ? 'is-invalid' : ''}>
					<FormControl
						type={state.passwordFieldType}
						name="password"
						autoComplete={props.autoComplete}
						autoFocus={props.autoFocus}
						placeholder="Wachtwoord"
						value={props.password}
						isInvalid={errorState}
						onChange={(event) => props.onChange(event.currentTarget.value)}
						onEnter={props.onEnter}/>
					<InputGroupAppendIcon
						iconClass={state.passwordFieldType === 'password' ? 'eye-open' : 'eye-close'}
						renderAppendContents={(icon) => <Button variant="secondary" onClick={this.handleVisibleToggle}>{icon}</Button>}
					/>
				</InputGroup>
			</FormGroup>
		);
	}
}

export default PasswordField;
